<template>
  <div class="container m-0 mt-lg-5 mb-4 d-flex flex-column gap-3">
    <div class="d-flex flex-column gap-3">
      <div class="d-flex flex-column flex-md-row justify-content-between gap-4 fondo-terciario rounded-4 p-4 pb-3 sombra-sm position-relative overflow-hidden">
        <div v-if="persona.FechaFallecimiento" class="position-absolute top-0 start-0 fondo-gris-oscuro fs-7 fw-bold p-1 px-2 rounded-bottom-end texto-principal-invertido"><p class="m-0">{{ $t('fallecido') }}</p></div>
        <div class="d-flex align-items-center gap-4 pb-2">
          <div class="d-flex align-items-center justify-content-start p-0 gap-2">
            <img v-if="persona.FotoUrl" :src="persona.FotoUrl" alt="Profile Picture" class="img-responsive" style="width: 120px; height: 120px; border-radius: 50%; object-fit: cover;" />
            <div v-else alt="Profile Picture" class="d-flex align-items-center justify-content-center img-responsive pb-1 fondo-gris" style="width: 120px; height: 120px; border-radius: 50%; object-fit: cover; padding: 2px;" >
              <svg width="60" height="60" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Dribbble-Light-Preview" transform="translate(-140.000000, -2159.000000)" fill="#ffffff"><g id="icons" transform="translate(56.000000, 160.000000)"><path d="M100.562548,2016.99998 L87.4381713,2016.99998 C86.7317804,2016.99998 86.2101535,2016.30298 86.4765813,2015.66198 C87.7127655,2012.69798 90.6169306,2010.99998 93.9998492,2010.99998 C97.3837885,2010.99998 100.287954,2012.69798 101.524138,2015.66198 C101.790566,2016.30298 101.268939,2016.99998 100.562548,2016.99998 M89.9166645,2004.99998 C89.9166645,2002.79398 91.7489936,2000.99998 93.9998492,2000.99998 C96.2517256,2000.99998 98.0830339,2002.79398 98.0830339,2004.99998 C98.0830339,2007.20598 96.2517256,2008.99998 93.9998492,2008.99998 C91.7489936,2008.99998 89.9166645,2007.20598 89.9166645,2004.99998 M103.955674,2016.63598 C103.213556,2013.27698 100.892265,2010.79798 97.837022,2009.67298 C99.4560048,2008.39598 100.400241,2006.33098 100.053171,2004.06998 C99.6509769,2001.44698 97.4235996,1999.34798 94.7348224,1999.04198 C91.0232075,1998.61898 87.8750721,2001.44898 87.8750721,2004.99998 C87.8750721,2006.88998 88.7692896,2008.57398 90.1636971,2009.67298 C87.1074334,2010.79798 84.7871636,2013.27698 84.044024,2016.63598 C83.7745338,2017.85698 84.7789973,2018.99998 86.0539717,2018.99998 L101.945727,2018.99998 C103.221722,2018.99998 104.226185,2017.85698 103.955674,2016.63598" id="profile_round-[#1342]"></path></g></g></svg>
            </div>
          </div>
          <div>
            <div class="d-flex flex-column align-items-baseline">
              <h1 class="fs-2 font-bold texto-principal m-0">{{ persona.Apellido + " " + persona.Nombre }}</h1>
              <p class="text-lg font-medium texto-secundario m-0">{{ persona.Cargo }}</p>
            </div>
          </div>
          <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
            <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
          </div>
        </div>
        <div class="d-flex flex-row flex-md-column flex-wrap justify-content-between" style="height: 100%;">
          <div class="d-flex flex-column gap-2 align-self-end" style="margin-bottom: 10px;">
          </div>

          <div class="d-flex justify-content-end">
            <!-- <p class="m-0 texto-secundario text-end fs-8">{{ $t('ultimaActualizacion') }}: {{ formattedUltimaActualizacion }}</p> -->
          </div>
        </div>
      </div>


      <!-- <div class="d-flex flex-wrap justify-content-start align-items-center overflow-hidden gap-3" style="border-bottom: 2px solid var(--fondo-gris-claro); max-width: 100vw;"> -->
      <div class="d-flex flex-wrap justify-content-start align-items-center overflow-hidden gap-3 fondo-terciario rounded-3 px-2 sombra-sm">
        <button
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 1}"
          @click="MenuVisible = 1"
        >
          {{ $t('datosPersonales') }}
        </button>
        <button
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 2}"
          @click="MenuVisible = 2"
        >
          {{ $t('preferencias') }}
        </button>
        <button v-if="hasVerHorariosPermission || hasVerMisHorariosYFichadasPermission"
          class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
          :class="{'active-btn': MenuVisible == 3}"
          @click="MenuVisible = 3"
        >
          {{ $t('horarios') }}
        </button>
      </div>
    </div>
    <div>
      <!----------------Datos Personales------------------->
      <div v-if="MenuVisible == 1">
        <div class="row">
          <div class="col-lg-8">
            <!-- Informacion Personal -->
            <InfoPersonalSection :persona="persona" :hasEditarPersonaPermission="hasEditarPersonaPermission" :isEditingPerfil="true" @updated="fetchPersona" />

            <!-- Informacion de Contacto -->
            <InfoContactoSection :persona="persona" :hasEditarPersonaPermission="hasEditarPersonaPermission" :isEditingPerfil="true" @updated="fetchPersona" />

            <!-- Direcciones -->
            <DireccionesSection :persona="persona" :hasEditarPersonaPermission="hasEditarPersonaPermission" :isEditingPerfil="true" @updated="fetchPersona" /> 
           
          </div>

          <div class="col-lg-4">
            <!-- Origen y Nacionalidad -->
            <OrigenYNacionalidadSection :persona="persona" :hasEditarPersonaPermission="hasEditarPersonaPermission" :isEditingPerfil="true" @updated="fetchPersona" />
            
            <!-- Informacion Institucional -->
            <InfoInstitucionalSection :persona="persona" :hasEditarPersonaPermission="hasEditarPersonaPermission" :isEditingPerfil="true" @updated="fetchPersona" />

            <!-- Contacto de emergencia -->
            <ContactoEmergSection :persona="persona" :hasEditarPersonaPermission="hasEditarPersonaPermission" :isEditingPerfil="true" @updated="fetchPersona" />
          </div>
        </div>
      </div>
      
      <!----------------Preferencias------------------->
      <div v-if="MenuVisible == 2">
        <div class="fondo-terciario rounded-4 p-4 sombra-sm">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h3 class="fs-4 font-bold texto-principal m-0">{{ $t('preferencias') }}</h3>
            <div v-if="preferenciasLoaded" class="d-flex gap-2">
              <button @click="editarPreferencias" v-if="!isEditingPreferencias" type="button" class="btn p-0 d-flex flex-row align-items-center justify-content-center tooltip-container border-0">
                <svg width="20" height="20" viewBox="0 0 24 24" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="tooltip-text">{{ $t('editar') }}</span>
              </button>
            </div>
          </div>
          <div v-if="loadingPreferencias" class="d-flex justify-content-center">
            <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
          </div>
          <div v-else-if="preferenciasLoaded" class="d-flex flex-column gap-3">
            <div class="form-check d-flex align-items-center gap-1">
              <input
                class="form-check-input mb-1"
                type="checkbox"
                id="esconderCumple"
                v-model="preferencias.EsconderCumple"
                :disabled="!isEditingPreferencias"
              />
              <label class="form-check-label texto-secundario" for="esconderCumple">
                {{ $t('esconderCumple') }}
              </label>
            </div>
            <div v-if="!EsconderCumple" class="form-check d-flex align-items-center gap-1">
              <input
                class="form-check-input mb-1"
                type="checkbox"
                id="esconderCumple"
                v-model="preferencias.EsconderEdadCumple"
                :disabled="!isEditingPreferencias"
              />
              <label class="form-check-label texto-secundario" for="esconderCumple">
                {{ $t('esconderEdadCumple') }}
              </label>
            </div>
            <div class="d-flex gap-2">
              <button
                v-if="isEditingPreferencias"
                class="btn success-btn"
                @click="savePreferencias"
                :disabled="loadingPreferencias"
              >
                {{ $t('guardar') }}
              </button>
              <button @click="cancelarPreferencias" v-if="isEditingPreferencias" type="button" class="btn secondary-btn">
                {{ $t('cancelar') }}
              </button>
            </div>
          </div>
          <div v-else>
            <p class="texto-secundario">{{ $t('noHayPreferencias') }}</p>
          </div>
        </div>
      </div>
      
      <!----------------Horarios------------------->
      <div v-if="MenuVisible == 3 && !loading && persona.IdPersona && (hasVerHorariosPermission || hasVerMisHorariosYFichadasPermission)" class="d-flex flex-column w-100 gap-3">
        <HorariosSection v-if="esProfesor" :persona="persona" @updated="fetchPersona" />
        <HorariosBackOfficeSection :persona="persona" :esPerfilPropio="true" @updated="fetchPersona" />
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted, computed, watch } from 'vue';
  import {useStore} from "vuex";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';
  import InfoPersonalSection from '@/components/PersonasTabs/DatosPersonales/InfoPersonalSection.vue';
  import InfoContactoSection from '@/components/PersonasTabs/DatosPersonales/InfoContactoSection.vue';
  import DireccionesSection from '@/components/PersonasTabs/DatosPersonales/DireccionesSection.vue';
  import OrigenYNacionalidadSection from '@/components/PersonasTabs/DatosPersonales/OrigenYNacionalidadSection.vue';
  import InfoInstitucionalSection from '@/components/PersonasTabs/DatosPersonales/InfoInstitucionalSection.vue';
  import ContactoEmergSection from '@/components/PersonasTabs/DatosPersonales/ContactoEmergSection.vue';
  import HorariosSection from '@/components/PersonasTabs/HorariosSection.vue';
  import HorariosBackOfficeSection from '@/components/PersonasTabs/HorariosBackOfficeSection.vue';

export default {
   name: 'VerDatosPersonas',
   components: {
     InfoPersonalSection,
     InfoContactoSection,
     DireccionesSection,
     OrigenYNacionalidadSection,
     InfoInstitucionalSection,
     ContactoEmergSection,
     HorariosSection,
     HorariosBackOfficeSection,
   },
   setup() {
    const { t } = useI18n();
    var loading = ref(false);
    var loadingMenu = ref(false);
    var asignarPermisos = ref(false);
    var asignarRoles = ref(false);
    var verRolesOcultos = ref(false);
    var hasEditarPersonaPermission = ref(false);
    var hasEditarListasPermission = ref(false);
    var hasVerHorariosPermission = ref(false);
    var hasVerMisHorariosYFichadasPermission = ref(false);
    var tieneAsignaturas = ref(false);
    const MenuVisible = ref(1);
    const store = useStore();
    const user = computed(() => store.state.user);
    const persona = ref({});
    const formularios = ref([]);
    const asignaturas = ref([]);
    const imagenError = ref(false);
    const preferencias = ref({
      EsconderCumple: false
    });
    const preferenciasOriginal = ref({
      EsconderCumple: false
    });
    const loadingPreferencias = ref(false);
    const isEditingPreferencias = ref(false);
    const preferenciasLoaded = ref(false);

    const checkAuth = async  () => {
      var permisoAComprobar = 'AsignarPermisos'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        asignarPermisos.value = true;
      }
      permisoAComprobar = 'AsignarRoles'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        asignarRoles.value = true;
      }
      permisoAComprobar = 'VerRolesOcultos'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        verRolesOcultos.value = true;
      }
      permisoAComprobar = 'EditarPersonas'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        hasEditarPersonaPermission.value = true;
      }
      permisoAComprobar = 'EditarListas'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        hasEditarListasPermission.value = true;
      }
      permisoAComprobar = 'VerHorarios'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        hasVerHorariosPermission.value = true;
      }
      permisoAComprobar = 'VerMisHorariosYFichadas'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        //Solo si esta mirando su perfil esto le va a dar true
        if(persona.value.IdPersona === user.value.idPersona){
          hasVerMisHorariosYFichadasPermission.value = true;
        }
      }
    };

    const fetchPersona = async () => {
      try {
        loading.value = true;
        const idUser = user.value.idPersona;
        const response = await api.get(`api/Persona/`+ idUser);
        //console.log(response.data)
        persona.value = response.data;

        // Se guarda el legajoId del rol de un empleado
        const specificRole = persona.value.PersonasRoles?.find(pr => pr.IdRol === '2bef46cb-2393-4626-ab12-55f7c48377d2');
        persona.value.LegajoIdEmpleado = specificRole ? specificRole.LegajoId : null;

        // Get latest roles by grouping and taking the most recent FechaHora
        let latestRoles = {};
        persona.value.HistorialRoles?.forEach(hr => {
          const roleId = hr.Rol.IdRol;
          if (!latestRoles[roleId] || new Date(hr.FechaHora) > new Date(latestRoles[roleId].FechaHora)) {
            latestRoles[roleId] = hr;
          }
        });
        let rolesArray = Object.values(latestRoles);

        if(!verRolesOcultos.value){
          persona.value.RolesVisuales = rolesArray.filter(pr => !pr.Rol?.Oculto).sort((a, b) => a.Rol.Rol.localeCompare(b.Rol.Rol))
        }else{
          persona.value.RolesVisuales = rolesArray.sort((a, b) => a.Rol.Rol.localeCompare(b.Rol.Rol))
        }

        console.log(persona.value)
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.error('Error al obtener datos del usuario:', error);
      }
    };
    const formattedUltimaActualizacion = computed(() => {
      if (!persona.value.UltimaActualizacion) return 'N/A';
      const date = new Date(persona.value.UltimaActualizacion);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    });

    const fetchPreferencias = async () => {
      try {
        loadingPreferencias.value = true;
        const idUser = user.value.idPersona;
        const response = await api.get(`api/Preferencias/persona/${idUser}`);
        preferencias.value = { ...response.data };
        preferenciasOriginal.value = { ...response.data };
        preferenciasLoaded.value = true;
      } catch (error) {
        console.error('Error al obtener preferencias:', error);
        // If no preferences exist, keep default values
        preferenciasLoaded.value = false;
      } finally {
        loadingPreferencias.value = false;
      }
    };

    const editarPreferencias = () => {
      isEditingPreferencias.value = true;
    };

    const cancelarPreferencias = () => {
      preferencias.value = { ...preferenciasOriginal.value };
      isEditingPreferencias.value = false;
    };

    const savePreferencias = async () => {
      try {
        loadingPreferencias.value = true;
        const idUser = user.value.idPersona;
        await api.put(`api/Preferencias/persona/${idUser}`, preferencias.value);
        preferenciasOriginal.value = { ...preferencias.value };
        isEditingPreferencias.value = false;
        // Optionally show success message
      } catch (error) {
        console.error('Error al guardar preferencias:', error);
        // Optionally show error message
      } finally {
        loadingPreferencias.value = false;
      }
    };

    const esProfesor = computed(() => {
      const roles = persona.value.PersonasRoles;
      if (!roles || !Array.isArray(roles)) return false;
      return roles.some(pr => pr.Rol && pr.Rol.Rol === 'Profesor');
    });

    onMounted(async () => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      // Load saved menu preference
      const savedMenu = localStorage.getItem('verPerfilMenuVisible');
      if (savedMenu) {
        MenuVisible.value = parseInt(savedMenu);
      }
      await fetchPersona();
      await checkAuth();
      await fetchPreferencias();
    });

    // Watch for changes in MenuVisible and save to localStorage
    watch(MenuVisible, (newVal) => {
      localStorage.setItem('verPerfilMenuVisible', newVal.toString());
    });

    return {
      t,
      persona,
      loading,
      loadingMenu,
      asignarRoles,
      asignarPermisos,
      MenuVisible,
      asignaturas,
      tieneAsignaturas,
      hasEditarPersonaPermission,
      hasEditarListasPermission,
      formularios,
      formattedUltimaActualizacion,
      fetchPersona,
      verRolesOcultos,
      imagenError,
      preferencias,
      preferenciasOriginal,
      loadingPreferencias,
      isEditingPreferencias,
      preferenciasLoaded,
      fetchPreferencias,
      editarPreferencias,
      cancelarPreferencias,
      savePreferencias,
      esProfesor,
      hasVerHorariosPermission,
      hasVerMisHorariosYFichadasPermission,
    };
  },
};
</script>

<style>
</style>